import { get, uniq } from 'lodash';
import _ from 'lodash/fp';
import numeral from 'numeral';


const filterConfig = {
  filter(home, { values }) {
    if (values.length === 0) {
      return true;
    }

    const result = values.some(value => {
      const start = get(value, 'value.start');
      const end = get(value, 'value.end');

      return home.sqft >= start && home.sqft <= end;
    });

    return result;
  },
  collectValues(homes, { config }) {
    const stop = _.get('stop', config);
    const list = uniq(homes.map(home => home.sqft || 0));
    let startVal = 1000;

    const ranges = [];
    const start = 1000;
    const max = 4000;

    const getIncrement = sqft => {
      if (sqft < 1000) {
        return 500;
      } else if (sqft < 4000) {
        return 500;
      }
      return 500;
    };

    const homeInSqftRange = (s, e) => price => {
      if (price >= s && price <= e) {
        return true;
      }
      return false;
    };

    while (startVal < max) {
      const increment = getIncrement(startVal);
      const end = startVal >= stop ? Infinity : startVal + increment;
      const matched = _.filter(homeInSqftRange(startVal, end), list);

      if (matched.length > 0) {
        const value = {
          prefix: '$',
          start: startVal <= start ? -Infinity : startVal,
          end,
        };
        const range = {
          value,
        };
        ranges.push(range);

        if (value.end === Infinity) {
          break;
        }
      }
      startVal += increment;
    }

    return ranges;
  },
  labelRender: ({ value }) => `${value.start === 1000 ? 'Below ' : numeral(value.start).format('0,0')} ${value.end === 4000 ? ' And Above' : `- ${numeral(value.end).format('0,0')}`}`,
  stop: 40000,
};

export default filterConfig;



// WEBPACK FOOTER //
// ./src/customFilters/Homes/CustomSQFT.js